export const labels = {
  customRange: 'Custom range',
}
